import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./authSlice";
import dummyDataReducer from "./dummyDataSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dummyData: dummyDataReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
